import { useState, useCallback } from 'react';

/**
 * Custom hook for managing retry state
 * Provides state and handlers for retry operations
 */
export const useRetryState = () => {
  const [retryState, setRetryState] = useState({
    isRetrying: false,
    attempt: 0,
    maxRetries: 0,
    delay: 0,
    error: null,
    success: false
  });

  const startRetry = useCallback(() => {
    setRetryState(prev => ({
      ...prev,
      isRetrying: true,
      error: null,
      success: false
    }));
  }, []);

  const updateRetry = useCallback((retryInfo) => {
    setRetryState(prev => ({
      ...prev,
      isRetrying: true,
      attempt: retryInfo?.attempt || 0,
      maxRetries: retryInfo?.maxRetries || 0,
      delay: retryInfo?.delay || 0,
      error: retryInfo?.error || null
    }));
  }, []);

  const completeRetry = useCallback((success = true, error = null) => {
    setRetryState(prev => ({
      ...prev,
      isRetrying: false,
      success,
      error: success ? null : error
    }));
  }, []);

  const resetRetry = useCallback(() => {
    setRetryState({
      isRetrying: false,
      attempt: 0,
      maxRetries: 0,
      delay: 0,
      error: null,
      success: false
    });
  }, []);

  return {
    retryState,
    startRetry,
    updateRetry,
    completeRetry,
    resetRetry
  };
};

export default useRetryState;